<header>
  <h1 tabindex="-1" class="step2Header" id="{{current ? 'main-content-focus': ''}}">{{ CONSTANTS.title }}</h1>
</header>

<form [formGroup]="userForm" #ngForm="ngForm" class="step-content" (ngSubmit)="handleContinue()">
  @if (isFormInvalid) {
    <p id="reviewErrors_step2" [class.is-invalid]="isFormInvalid" aria-live="polite" tabindex="-1">
      <i class="allycon-error-fill"></i>
      {{ displayFormErrorsMessage }} {{ CONSTANTS.reviewErrors }}
    </p>
  }

  <div class="form-group">
    <label for="firstName" id="firstName-label">{{ CONSTANTS.firstName }}</label>
    <div class="control-wrapper">
      <input formControlName="firstName" id="firstName" class="form-control" [class.is-invalid]="isFirstNameInvalid" aria-required=“true” aria-labelledby="firstName-label firstName-error">
      @if (isFirstNameInvalid) {
        <span class="invalid-feedback" id="firstName-error">{{ CONSTANTS.errorMessages.firstName }}</span>
      }
    </div>
  </div>

  <div class="form-group">
    <label for="lastName" id="lastName-label">{{ CONSTANTS.lastName }}</label>
    <div class="control-wrapper">
      <input formControlName="lastName" id="lastName" class="form-control" [class.is-invalid]="isLastNameInvalid" aria-required=“true” aria-labelledby="lastName-label lastName-error">
      @if (isLastNameInvalid) {
        <span class="invalid-feedback" id="lastName-error">{{ CONSTANTS.errorMessages.lastName }}</span>
      }
    </div>
  </div>

  <div class="form-group">
    <app-email-input
      [inputForm]="userForm"
      [emailInputConfig]="emailInputConfig"
      [translations]="CONSTANTS"
      [invalidFormatEmail]="invalidFormatEmail"
      [emailContainsSpecialChars]="emailContainsSpecialChars">
    </app-email-input>
  </div>

  <div class="form-group">
    <label for="mobilePhone" id="mobilePhone-label">{{ CONSTANTS.mobilePhone }} <span class="text-lower">({{ CONSTANTS.optional }})</span></label>
    <div class="control-wrapper">
      <input formControlName="mobilePhone" 
      id="mobilePhone" 
      type="tel"
      mask="000-000-0000"
      class="form-control" 
      [class.is-invalid]="isMobilePhoneInvalid" 
      aria-labelledby="mobilePhone-label mobilePhone-error">
      @if (isMobilePhoneInvalid) {
        <span class="invalid-feedback" id="mobilePhone-error">{{ CONSTANTS.errorMessages.mobilePhone }}</span>
      }
    </div>
  </div>

  @if (featureMobileNotif) {
    <div class="form-group">
      <p class="mobilePhoneClause">{{ CONSTANTS.mobilePhoneClause }}</p>
    </div>
  }

  @if (showAuctionAccessId) {
    <div class="form-group">
      <label for="auctionAccess" id="auctionAccess-label">{{ CONSTANTS.auctionAccess }} @if (isAuctionAccessIdOptional) {
        <span class="text-lower">({{ CONSTANTS.optional }})</span>
      }</label>
      <div class="control-wrapper">
        <input formControlName="auctionAccess" 
        id="auctionAccess" 
        class="form-control" 
        mask="000000000"
        inputmode="numeric"
        [class.is-invalid]="isAuctionAccessInvalid" 
        placeholder="{{ CONSTANTS.auctionAccessIdPlaceHolder }}" 
        aria-labelledby="auctionAccess-label auctionAccess-error">
        @if (isAuctionAccessInvalid) {
          <span class="invalid-feedback" id="auctionAccess-error">{{ CONSTANTS.errorMessages.auctionAccess }}</span>
        }
      </div>
    </div>
  }

  <div class="mt-4 control-wrapper__actions">
    <button data-track-elem="button" [attr.data-track-name]="CONSTANTS.button.continue" type="submit" class="btn btn-primary" [appTrackButton]="CONSTANTS.button.continue">{{ CONSTANTS.button.continue }}</button>
    <button data-track-elem="button" [attr.data-track-name]="CONSTANTS.button.cancel" type="button" routerLink="/login" class="btn btn-link cancel-btn"  [appTrack]="{name: CONSTANTS.button.cancel, trigger: 'interstital'}">{{ CONSTANTS.button.cancel }}</button>
  </div>
</form>
